import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogConfirmData, DialogVariant, IconConfig } from '../dialog.type';
import { color } from 'html2canvas/dist/types/css/types/color';

@Component({
  selector: 'app-dialog-confirm-action',
  templateUrl: './dialog-confirm-action.component.html',
  styleUrls: ['./dialog-confirm-action.component.scss'],
})
export class DialogConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data?: DialogConfirmData,
  ) {}
  password = '';
  form: Record<string, any> = {};

  agree() {
    if (this.data?.requirePassword) {
      const required = this.data?.passwordConfig?.required ?? true;

      if (required && !this.password) return;

      return this.dialogRef.close(this.password);
    }

    if (this.data?.formConfig) {
      const invalid = this.data.formConfig.controls.some(
        (c) => c.required && !this.form[c.key],
      );

      if (invalid) return;

      return this.dialogRef.close(this.form);
    }

    // default
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
  get titles(): string[] {
    return Array.isArray(this.data?.title)
      ? this.data.title
      : [this.data?.title].filter((v): v is string => !!v);
  }

  get messages(): string[] {
    if (!this.data?.message) return [];
    return Array.isArray(this.data.message)
      ? this.data.message
      : [this.data.message];
  }

  get confirmText(): string {
    return this.data?.confirm?.text ?? 'view_value.confirm';
  }

  get cancelText(): string {
    return this.data?.cancel?.text ?? 'view_value.cancel';
  }

  get confirmVariant(): DialogVariant {
    return this.data?.confirm?.variant ?? 'primary';
  }

  get cancelVariant(): DialogVariant {
    return this.data?.cancel?.variant ?? 'neutral';
  }

  get iconConfig(): IconConfig {
    const iconConfig = this.data?.iconConfig;
    return {
      showBg: iconConfig?.showBg ?? true,
      bgColor: iconConfig?.bgColor ?? `var(--second-color)`,
      color: iconConfig?.color ?? `#fff`,
    };
  }
}
